import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/Layout';

const Index = ({ element }) => (
	<Layout>{ element }</Layout>
);

Index.propTypes = {
	element: PropTypes.node.isRequired,
};

export default Index;
